import { useEffect } from 'react';

export function useKeyDown(
    element: HTMLElement,
    triggerKey: string,
    callback: Function
) {
    useEffect(() => {
        if (element) {
            const onKeyDown = ({ key }: { key: string }) => {
                if (key === triggerKey) {
                    callback();
                }
            };

            element.addEventListener('keydown', onKeyDown);

            return () => {
                element.removeEventListener('keydown', onKeyDown);
            };
        }
    }, [triggerKey, callback, element]);
}
